var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9995 9.4692C18.1409 9.60219 18.2292 9.79103 18.2292 10.0005C18.2292 10.0014 18.2292 10.0022 18.2292 10.0031C18.2287 10.189 18.1575 10.3747 18.0157 10.5166L13.849 14.6832C13.5643 14.968 13.1026 14.968 12.8178 14.6832C12.5331 14.3985 12.5331 13.9368 12.8178 13.652L15.7402 10.7297L7.50008 10.7297C7.09737 10.7297 6.77091 10.4032 6.77091 10.0005C6.77091 9.59778 7.09737 9.27132 7.50008 9.27132L15.7392 9.27132L12.8178 6.34991C12.5331 6.06515 12.5331 5.60347 12.8178 5.31871C13.1026 5.03395 13.5643 5.03395 13.849 5.31871L17.9995 9.4692ZM7.39575 2.50065C7.39575 2.90336 7.06929 3.22982 6.66658 3.22982L4.16658 3.22982C3.91794 3.22982 3.67949 3.32859 3.50367 3.5044C3.32786 3.68022 3.22908 3.91868 3.22908 4.16732L3.22908 15.834C3.22908 16.0826 3.32786 16.3211 3.50367 16.4969C3.67949 16.6727 3.91794 16.7715 4.16658 16.7715L6.66658 16.7715C7.06929 16.7715 7.39575 17.0979 7.39575 17.5007C7.39575 17.9034 7.06929 18.2298 6.66658 18.2298L4.16658 18.2298C3.53117 18.2298 2.92178 17.9774 2.47247 17.5281C2.02317 17.0788 1.77075 16.4694 1.77075 15.834L1.77075 4.16732C1.77075 3.5319 2.02317 2.92251 2.47248 2.47321C2.92178 2.0239 3.53117 1.77148 4.16658 1.77148L6.66658 1.77148C7.06929 1.77148 7.39575 2.09794 7.39575 2.50065Z",
    fill: "#4D4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckout);
export default __webpack_public_path__ + "static/media/checkout.75d1cb55dd2755c12adcc419810d11b0.svg";
export { ForwardRef as ReactComponent };